<template>
    <div>
      <div class="air__utils__heading">
        <div class="row">
          <div class="col-6 col-sm-8">
            <h5>Categories</h5>
          </div>
          <div class="col-6 col-sm-4 text-right">
            <new-category v-if="pagepermission.insertable" @created="handleCreated"/>
          </div>
        </div>
      </div>
      <div class="row justify-content-center" v-if="pagepermission.viewable">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <categories-table :data="data" :rolesetting="pagepermission" :loading="loading" @updateTable="handleUpdateTable" />
            </div>
          </div>
          <div class="text-right">
            <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
            </a-pagination>
          </div>
        </div>
      </div>
      <div class="row justify-content-center" v-else>
        <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
      </div>
    </div>
  </template>

<script>
import CategoriesTable from '@/components/library/category/index'
import NewCategory from '@/components/library/category/new'

export default {
  components: {
    CategoriesTable,
    NewCategory,
  },
  beforeMount: function() {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('library', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.getCategories()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
  methods: {
    getCategories: function() {
      this.loading = true
      this.$http.get('api/library/category', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
        console.log(this.data)
      })
    },
    handleCreated: function() {
      this.getCategories()
    },
    handleUpdateTable: function() {
      this.getCategories()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getCategories()
    },
    onChange(current) {
      this.current = current
      this.getCategories()
    },
  },
}
</script>
  <style>
  .error { padding: 25px 5px; }
  </style>
